import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
  GET_SERVICES,
  GET_PAGERDUTY_SERVICES,
  GET_OPSGENIE_SERVICES,
  GET_NOTIFICATION_CHANNEL,
  GET_REDIRECT_SLACK,
  POST_SERVICE,
  POST_RESEND_SERVICE_EMAIL_VERIFICATION,
  POST_SERVICE_FAIL,
  POST_UPDATE_SERVICE,
  GET_SPECIFIC_SERVICES,
  GET_INTEGRATION_KEYS,
  POST_CREATE_INTEGRATION_KEY,
  GET_INTEGRATION_ACTION_URL,
  POST_TEST_NOTIFICATION,
  GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL,
  GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID,
  POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID,
  CREATE_UPDATE_TAG,
  GET_TAG_VALUES,
  DELETE_TAG_VALUE,
  GET_ALL_KEY_NAMES, SET_MAINTENANCE_WINDOW_BY_ID,
} from "./actionTypes";

import {
  getServicesSuccess,
  getServicesFail,
  postServiceFail,
  getNotificationChannelSuccess,
  getNotificationChannelFail,
  getPagerDutyServicesSuccess,
  getPagerDutyServicesFail,
  getOpsGenieServicesSuccess,
  getOpsGenieServicesFail,
  postServiceSuccess,
  getRedirectSlackSuccess,
  postResendEmail,
  getRedirectSlackFail,
  postUpdateServiceFail,
  postResendServiceEmailSuccess,
  postResendServiceEmailFail,
  postUpdateServiceSuccess,
  getSpecificServicesSuccess,
  getSpecificServicesFail,
  getIntegrationKeysSuccess,
  getIntegrationKeysFail,
  postCreateIntegrationKeyFail,
  postCreateIntegrationKeySuccess,
  getIntegrationActionURLSuccess,
  getIntegrationActionURLFail,
  postTestNotificationSuccess,
  postTestNotificationFail,
  getBluejayMasterCommunicationChannelsSuccess,
  getBluejayMasterCommunicationChannelsFail,
  getBluejayCommunicationChannelByServiceIdSuccess,
  getBluejayCommunicationChannelByServiceIdFail,
  postBluejayCommunicationChannelByServiceIdFail,
  postBluejayCommunicationChannelByServiceIdSuccess,
  createOrUpdateTagSuccess,
  createOrUpdateTagFail,
  fetchTagValuesByServiceSuccess,
  fetchTagValuesByServiceFail,
  deleteTagValueSuccess,
  deleteTagValueFail,
  fetchAllKeyNamesSuccess,
  fetchAllKeyNamesFail, postSetMaintenanceByServiceIdSuccess, postSetMaintenanceByServiceIdFail,
} from "./actions";

import {
  getServices,
  postAddService,
  postUpdateServiceUrl,
  redirect_slack,
  getSpecificServiceUrl,
  getIntegrationKeysUrl,
  postCreateIntegrationKeyUrl,
  getIntegrationActionURLAPI,
  postResendServiceEmailUrl,
  getNotificationChannelsUrl,
  getPagerdutyServicesUrl,
  getOpsGenieServicesUrl,
  postTestNotificationUrl,
  getMasterCommunicationChannelsUrl,
  getBluejayCommunicationChannelByServiceIdUrl,
  updateBluejayCommunicationChannelByServiceIdUrl,
  createAndUpdateTagUrl,
  getTagValuesByService,
  softDeleteTagValue,
  getAllKeyNames,
  setMaintenanceWindowByServiceIdUrl,
} from "../../helpers/fakebackend_helper";

import { showNotification } from "components/Common/notification";

function* onGetServices() {
  try {
    const response = yield call(getServices);
    yield put(getServicesSuccess(response));
  } catch (error) {
    yield put(getServicesFail(error.response.data.message));
  }
}

function* onGetIntegrationKeys({ payload: { application_service_id } }) {
  try {
    const response = yield call(getIntegrationKeysUrl, application_service_id);
    yield put(getIntegrationKeysSuccess(response));
  } catch (error) {
    yield put(getIntegrationKeysFail(error.response.data.message));
  }
}

function* onRedirectSlack() {
  try {
    const response = yield call(redirect_slack);
    yield put(getRedirectSlackSuccess(response));
  } catch (error) {
    yield put(getRedirectSlackFail(error.response.data.message));
  }
}

function* onPostAddService({ payload: { service } }) {
  try {
    const response = yield call(postAddService, {
      service_name: service.name,
      email_id: service.email_id,
      slack_channel_name: service.slack_channel,
      bluejay_oncall_policy_id: service.on_call_policy,
      selected_notification_channels: service.selected_notification_channels,
      bluejay_team_id: service.bluejay_team_id
    })
    if (response) {
      showNotification("success", "Added Service");
      window.location.reload();
    }
  } catch (error) {
    yield put(postServiceFail(error.response.data.message));
  }
}

function* onPostUpdateService({ payload: { service } }) {
  try {
    const response = yield call(postUpdateServiceUrl, {
      application_service_id: service.application_service_id,
      service_name: service.new_name,
      email_id: service.new_email,
      slack_channel_name: service.new_slack_channel_name,
      ms_team_channel_name: service.new_ms_team_channel_name,
      bluejay_oncall_policy_id: service.on_call_policy,
      bluejay_team_id: service.bluejay_team_id,
      ms_team_channel_id: service.ms_team_id
    })
    if (response) {
      showNotification("success", "Updated Service");
    }
    yield put(postUpdateServiceSuccess(response));
  } catch (error) {
    yield put(postUpdateServiceFail(error.response.data.message));
  }
}

function* onPostResendEmail({ payload: { application_service_id } }) {
  try {
    let data = {
      application_service_id: application_service_id
    }
    const response = yield call(postResendServiceEmailUrl, data)
    yield put(postResendServiceEmailSuccess(response))
  } catch (error) {
    yield put(postResendServiceEmailFail(error.response.data.message))
  }
}

function* onPostCreateIntegrationKey({ payload: { application_service_id, integration_name, integration_type } }) {
  try {
    let data = {
      application_service_id: application_service_id,
      integration_name: integration_name,
      integration_type: integration_type
    }
    const response = yield call(postCreateIntegrationKeyUrl, data)
    yield put(postCreateIntegrationKeySuccess(response));
  } catch (error) {
    yield put(postCreateIntegrationKeyFail(error.response.data.message));
  }
}

function* onGetServiceByID(service_id) {
  try {
    const response = yield call(getSpecificServiceUrl, service_id.payload);
    yield put(getSpecificServicesSuccess(response));
  } catch (error) {
    yield put(getSpecificServicesFail(error.message));
  }
}

function* onGetIntegrationActionURLByID(integration_key_id) {
  try {
    const response = yield call(getIntegrationActionURLAPI, integration_key_id.payload.integration_key_id);
    yield put(getIntegrationActionURLSuccess(response));
  } catch (error) {
    yield put(getIntegrationActionURLFail(error.message));
  }
}

function* onGetNotificationChannel() {
  try {
    const response = yield call(getNotificationChannelsUrl);
    yield put(getNotificationChannelSuccess(response));
  } catch (error) {
    yield put(getNotificationChannelFail(error.message));
  }
}

function* onGetPagerdutyServices() {
  try {
    const response = yield call(getPagerdutyServicesUrl);
    yield put(getPagerDutyServicesSuccess(response));
  } catch (error) {
    yield put(getPagerDutyServicesFail(error.message));
  }
}

function* onGetOpsgenieServices() {
  try {
    const response = yield call(getOpsGenieServicesUrl);
    yield put(getOpsGenieServicesSuccess(response));
  } catch (error) {
    yield put(getOpsGenieServicesFail(error.message));
  }
}

function* onPostTestNotification({ payload: { application_service_id } }) {
  try {
    let data = {
      application_service_id: application_service_id
    }
    const response = yield call(postTestNotificationUrl, application_service_id);
    yield put(postTestNotificationSuccess(response));
  } catch (error) {
    yield put(postTestNotificationFail(error.message));
  }
}

function* onGetBluejayMasterCommunicationChannels(){
  try {
    const response = yield call(getMasterCommunicationChannelsUrl);
    yield put(getBluejayMasterCommunicationChannelsSuccess(response));
  } catch (error) {
    yield put(getBluejayMasterCommunicationChannelsFail(error.response.data.message));
  }
}


function* onGetBluejayCommunicationChannelsByServiceId({payload:service_id}){
  try {
    const response = yield call(getBluejayCommunicationChannelByServiceIdUrl, service_id);
    yield put(getBluejayCommunicationChannelByServiceIdSuccess(response));
  } catch (error) {
    yield put(getBluejayCommunicationChannelByServiceIdFail(error.response.data.message));
  }
}

function* onPostBluejayCommunicationChannelsByServiceId(data){
  try {
    const response = yield call(updateBluejayCommunicationChannelByServiceIdUrl,data.payload)
    yield put(postBluejayCommunicationChannelByServiceIdSuccess(response));
    showNotification("success", "Updated Service");
    window.location.reload()
  }catch (error){
    yield put(postBluejayCommunicationChannelByServiceIdFail(error.response.data.message));
  }
}
function* onCreateOrUpdateTag({payload:data}) {
  try {
    const response = yield call(createAndUpdateTagUrl, data);
    if (response) {
      showNotification('success',response.message)
      if (response.application_service_id){
        yield put({type:GET_TAG_VALUES, payload: {serviceId:response.application_service_id}});
      }
  }
    yield put(createOrUpdateTagSuccess(response));
  } catch (error) {
    yield put(createOrUpdateTagFail(error.message));
  }
}

function* onFetchTagValuesByService({payload:data}) {
  try {
    const response = yield call(getTagValuesByService, data.serviceId);
    yield put(fetchTagValuesByServiceSuccess(response));
  } catch (error) {
    yield put(fetchTagValuesByServiceFail(error.message));
  }
}

function* onDeleteTagValue(action) {
  try {
    const response = yield call(softDeleteTagValue, action.payload);
    if (response) {
      showNotification("success", "Tag successfully deleted!");
  }
    yield put(deleteTagValueSuccess(response));

  } catch (error) {
    yield put(deleteTagValueFail(error.message));
  }
}

function* onFetchAllKeyNames() {
  try {
    const response = yield call(getAllKeyNames);
    yield put(fetchAllKeyNamesSuccess(response));
  } catch (error) {
    yield put(fetchAllKeyNamesFail(error.message));
  }
}

function* onSetMaintenanceWindowById({payload: data}) {
 try{
   const payload = {
     "duration_in_minutes": data.duration_in_minutes,
     "application_service_id": data.service_id
   }
   const response = yield call(setMaintenanceWindowByServiceIdUrl, payload);
   yield put(postSetMaintenanceByServiceIdSuccess(response))
 } catch (error) {
   yield put(postSetMaintenanceByServiceIdFail(error.message));
 }
}

function* serviceSaga() {
  yield takeEvery(GET_SERVICES, onGetServices);
  yield takeEvery(POST_RESEND_SERVICE_EMAIL_VERIFICATION, onPostResendEmail);
  yield takeEvery(POST_SERVICE, onPostAddService);
  yield takeEvery(GET_REDIRECT_SLACK, onRedirectSlack);
  yield takeEvery(POST_UPDATE_SERVICE, onPostUpdateService);
  yield takeEvery(GET_SPECIFIC_SERVICES, onGetServiceByID);
  yield takeEvery(GET_INTEGRATION_KEYS, onGetIntegrationKeys);
  yield takeEvery(POST_CREATE_INTEGRATION_KEY, onPostCreateIntegrationKey);
  yield takeEvery(GET_INTEGRATION_ACTION_URL, onGetIntegrationActionURLByID);
  yield takeEvery(GET_NOTIFICATION_CHANNEL, onGetNotificationChannel);
  yield takeEvery(GET_PAGERDUTY_SERVICES, onGetPagerdutyServices);
  yield takeEvery(GET_OPSGENIE_SERVICES, onGetOpsgenieServices);
  yield takeEvery(POST_TEST_NOTIFICATION, onPostTestNotification);
  yield takeEvery(GET_MASTER_BLUEJAY_COMMUNICATION_CHANNEL, onGetBluejayMasterCommunicationChannels);
  yield takeEvery(GET_BLUEJAY_COMMUNICATION_CHANNEL_BY_SERVICE_ID,onGetBluejayCommunicationChannelsByServiceId);
  yield takeEvery(POST_UPDATE_BLUEJAY_COMMUNICATION_CHANNEL_BY_ID,onPostBluejayCommunicationChannelsByServiceId);
  yield takeEvery(CREATE_UPDATE_TAG, onCreateOrUpdateTag);
  yield takeEvery(GET_TAG_VALUES, onFetchTagValuesByService);
  yield takeEvery(DELETE_TAG_VALUE, onDeleteTagValue);
  yield takeEvery(GET_ALL_KEY_NAMES, onFetchAllKeyNames);
  yield takeEvery(SET_MAINTENANCE_WINDOW_BY_ID, onSetMaintenanceWindowById);
}

export default serviceSaga;
